import { render, staticRenderFns } from "./DialogPermissoesPerfil.vue?vue&type=template&id=7e6089de&scoped=true&"
import script from "./DialogPermissoesPerfil.vue?vue&type=script&lang=js&"
export * from "./DialogPermissoesPerfil.vue?vue&type=script&lang=js&"
import style0 from "./DialogPermissoesPerfil.vue?vue&type=style&index=0&id=7e6089de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6089de",
  null
  
)

export default component.exports